export const COUNT_OF_WIDGETS_MOBILE = 2;
export const COUNT_OF_WIDGETS_TABLET = 3;
export const COUNT_OF_WIDGETS_DESKTOP = 4;
